export const MigrationTarget = {
  PROJECT: 'PROJECT',
  GROUP: 'GROUP'
};
